<template>
  <section>
    <div class="card">
      <div class="by-tag-sales-repartition">
        <h3> Défis reçus en attente d'acceptation</h3>
        <div
          v-if="to_accept_challenges.length > 0 && !isAdmin"
          style="text-align: center"
        >
          <div
            v-for="(chall, index) in  to_accept_challenges"
            style="margin-top: 5px;"
            :key="index"
          >
            L'équipe <strong>{{getWeezyName(chall.weezy1_id)}}</strong> vous a défié !
            <button
              class="button is-success is-small"
              id="clear"
              @click="acceptChallenge(chall.id)"
            >
              <span><i class="fal fa-check"></i> Relever le défi</span>
            </button>
            <button
              class="button is-danger is-small"
              style="margin-left: 10px"
              id="clear"
              @click="acceptChallenge(chall.id, false)"
            >
              <span><i class="fal fa-times"></i> Refuser le défi</span>
            </button>
          </div>
        </div>
        <div
          v-else
          class="no-waiting"
        >
          Aucun défi reçu en attente d'acceptation
        </div>

        <div style="margin-left: 25px; margin-right: 25px; margin-top: 25px; ">
          <b-loading
            :is-full-page="false"
            :active.sync="isLoading"
            :can-cancel="true"
          ></b-loading>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
import http from "@/modules/request";

export default {
  name: "toAcceptChallenges",
  props: ["to_accept_challenges", "weezys", "isAdmin"],

  data: () => {
    return {
      isEmpty: false,
      isLoading: false
    };
  },
  methods: {
    acceptChallenge(challenge_id, accept = true) {
      http
        .post("/challenges/acceptreject", {
          accept: accept,
          challenge_id: challenge_id
        })
        .then(
          function(response) {
            this.succesToast("Défi accepté/refusé avec succès");
            this.$parent.getChallenges();
          }.bind(this)
        )
        .catch(function(error) {
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
          this.errorToast("Échec d'acceptation du défi");
        });
    },
    getWeezyName(fromWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        if (fromWeezyId == this.weezys[i].id) {
          return this.weezys[i].name;
        }
      }
    },
    errorToast(message) {
      this.$parent.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$parent.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  padding-left: 30px;
}
.b-text-field {
  width: 150px;
}

p {
  text-align: left;
  color: rgb(42, 163, 214);
}

.card {
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;

  box-shadow: none;
  min-width: 1000px;
}

.board {
  padding-top: 120px;
  width: 800px;
  display: grid;
  justify-content: space-between;
}

.by-tag-sales-repartition {
  background-color: #2aa3d622;
  border-radius: 10px;
  padding-bottom: 10px;
}

li {
  list-style-type: none;
  vertical-align: middle;
}

ul {
  display: flex;
  justify-content: space-around;
}

.avatar-list {
  vertical-align: middle;
}

.graph {
  margin-bottom: -60px !important;
}

.loading-overlay {
  padding-right: 20px;
}

img {
  border-radius: 50%;
}

h3 {
  padding-top: 10px;
  padding-bottom: 20px;
  text-align: center;
  height: 15px;
  font-size: 1.5em;
  color: rgb(42, 163, 214);
}

.no-waiting {
  margin-top: 10px;
  text-align: center;
}
</style>